<template lang="html">
  <div class="messages-wrapper">
    <div class="table-wrapper">
      <table v-if="chats.length > 0">
        <thead>
          <tr>
            <td style="width: 180px;">{{$t("main.name")}}</td>
            <td></td>
            <td style="width: 120px;">{{$t("profile.purchase.date")}}</td>
          </tr>
        </thead>
        <tbody>
          <tr
            :class="{ active: chat.usr_id === activeChat, seen: chat.msg_read === 1 }"
            v-for="chat in chats"
            :key="chat.usr_id"
            @click="activeChat = chat.usr_id"
          >
            <td>{{chat.usr_name}}</td>
            <td>{{chat.msg_message}}</td>
            <td>{{chat.msg_date | moment('DD.MM.YYYY')}}</td>
          </tr>
        </tbody>
      </table>
      <div v-else class="no-data">
        {{$t("profile.notifications.note")}}
      </div>
    </div>
    <chat v-if="activeChat !== null" :chat="activeChat"/>
  </div>
</template>

<script>
import { api } from '@/api'
import eventBus from '@/shared/eventBus.js'
import Chat from '@/components/profile/chat.vue'
export default {
  name: 'messages',
  components: {
    Chat
  },
  data () {
    return {
      chats: [],
      activeChat: null
    }
  },
  mounted () {
    this.getMessages()
    eventBus.$on('refreshMessages', this.getMessages)
  },
  methods: {
    getMessages () {
      api.getMessages().then(res => {
        this.chats = res.data.data
        console.log(this.chats)
      }).catch(e => {
        console.log(e)
      })
      api.getNotificationsCount().then(res => {
        this.$store.commit('setNotificationCounters', res.data)
      })
    }
  },
  destroyed () {
    eventBus.$off('refreshMessages')
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/tableStyles.scss';
.messages-wrapper {
  display: flex;
  .table-wrapper {
    flex-grow: 1;
  }
}
@media only screen and (max-width: 1200px){
  .messages-wrapper {
    flex-direction: column;

    .table-wrapper {
      margin-bottom: 30px;
    }
  }
}
table {
  table-layout: fixed;
  tbody {
    tr {
      cursor: pointer;
      td {
        color: #606060;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    tr.seen {
      td {
        color: #7B7B7B;
        background: rgba(196, 196, 196, .15);
        font-weight: 500;
      }
    }
    tr.active {
      td {
        background: #FAEDEF;
      }
    }
  }
}
</style>
